// extracted by mini-css-extract-plugin
export default {"ms-Fabric--isFocusHidden":"App_ms-Fabric--isFocusHidden__Knh3a","app":"App_app__zr1wm","container":"App_container__Rt8T2"};